:host {
	aspect-ratio: 1/1;
	display: inline-block;
	height: 48px;
}

.zds-spinner {
	direction: ltr;
	height: 100%;
	line-height: 0;
	position: relative;
	width: 100%;

	&__spinner-container {
		height: 100%;
		position: absolute;
		rotate: -90deg;
		width: 100%;
	}

	&__spinner-svg {
		fill: transparent;
	}

	&__spinner-circle {
		stroke: var(--zds-spinner-color);
		transition: stroke-dashoffset 250ms var(--zds-transition-type-ease);
	}

	&--indeterminate &__spinner-container {
		animation: 800ms linear infinite indeterminate;
	}
}

@keyframes indeterminate {
	0% {
		rotate: -90deg;
	}

	100% {
		rotate: 270deg;
	}
}
